// Loading.js

const Loading = () => {
  return (
    <div className="loadingContainer">
      <div className="loading"></div>
    </div>
  );
};

export default Loading;
